import React, { FC, useEffect } from 'react';
import { symbol as Symbol } from '@wix/santa-editor-symbols';
import { useActionsDispatcher } from '../../../../../../ActionsDispatcher';
import { useCurrentCategory } from '../../../../../../CurrentCategoryProvider';
import { useBoolean } from '../../../../../../hooks/useBoolean';
import { useConditionHelpers, useUtils } from '../../../../../../UtilsProvider';
import { ActionItem } from '../../../components/ActionItem';
import type { VeloDevModeProps } from './VeloDevMode.types';
import styles from './VeloDevMode.scss';
import type { VeloCustomSection } from '@wix/add-panel-common';

export const VeloDevMode: FC<VeloDevModeProps> = ({ section }) => {
  const category = useCurrentCategory();
  const { isDevModeOn: isDevModeOnHelper } = useConditionHelpers();
  const {
    translate,
    media: { getMediaUrl },
  } = useUtils();
  const { dispatchToggleDevMode } = useActionsDispatcher();

  const isDevModeOnInEditor = isDevModeOnHelper();

  const { value: isDevModeOnInState, set: setDevMode, toggle: toggleDevMode } = useBoolean(isDevModeOnInEditor);

  useEffect(() => {
    setDevMode(isDevModeOnInEditor);
  }, [isDevModeOnInEditor, setDevMode]);

  const {
    translations: { title: sectionTitle },
    props: { itemId, title, desc, image, symbol, tooltip, toggledState },
  } = section as VeloCustomSection;

  return (
    <div>
      <ActionItem
        className={styles.actionItem}
        dataHook="velo-dev-mode"
        componentType="wysiwyg.viewer.components.HtmlComponent"
        title={translate(title)}
        description={translate(desc)}
        illustration={<img src={getMediaUrl(image)} alt="" />}
        actionIcon={<Symbol name={isDevModeOnInState ? toggledState.symbol : symbol} />}
        tooltipContent={translate(isDevModeOnInState ? toggledState.tooltip : tooltip)}
        onClick={() => {
          dispatchToggleDevMode({ itemId, sectionTitle, categoryId: category.id });
          toggleDevMode();
        }}
        shouldTranslate={false}
      />
    </div>
  );
};
